import { Cursor } from 'api/search/search.types'

import { searchPath } from '../../Search.paths'

export const createCursorPath = (cursor: Cursor): string => {
  const url = Object.keys(cursor)
    .sort()
    .reduce((acc, item) => {
      if (item === 'locale') {
        return acc
      }
      return `${acc}${item}/${cursor[item as keyof Cursor]}/`
    }, '')

  return `${searchPath}/${url}`
}
